import React, {PureComponent, Fragment} from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import {v4 as uuid} from 'uuid';
import { T } from '../../components/I18n';

import Button from '../Button';
import Icon from '../Icon';
import Menu from '../Menu';

class ListItem extends PureComponent {
  key = this.props.id || uuid();
  state = {
    menuOpen: false
  };

  toggleMenu = () => {
    this.setState(prevState => ({menuOpen: !prevState.menuOpen}));
  }
  
  renderMenu(options) {
    const {menuOpen} = this.state;

    return (
      <Menu open={menuOpen} position="bottom-end" relativeTo={`list-item-${this.key}`} onClose={this.toggleMenu}>
        {options.map((option, i) => {
          const {title, ...buttonProps} = option;
          return <Menu.Option key={i} {...buttonProps}>{title}</Menu.Option>;
        })}
      </Menu>
    );
  }

  renderOptions = isSmallScreen => {
    const {options} = this.props;

    if (!options || options.length < 0) {
      return null;
    }

    if (options.length === 1) {
      const {title, ...buttonProps} = options[0];
      return <Button secondary {...buttonProps}>{title}</Button>;
    }

    if (isSmallScreen) {
      return (
        <Fragment>
          <Button secondary id={`list-item-${this.key}`} onClick={this.toggleMenu}>
            <Icon name="chevron-down" />
          </Button>
          {this.renderMenu(options)}
        </Fragment>
      );
    }

    const [first, ...rest] = options;

    return (
      <Fragment>
        <Button.Group>
          <Button {...first}>{first.title}</Button>
          <Button id={`list-item-${this.key}`} onClick={this.toggleMenu}>
            <Icon name="chevron-down" />
          </Button>
        </Button.Group>
        {this.renderMenu(rest)}
      </Fragment>
    );
  }

  render() {

    const {children, avatar, title, subtitle, options, first, notice, ...props} = this.props;
    return (
      <Container first={first} {...props}>
        {avatar && (
          <AvatarContainer>{avatar}</AvatarContainer>
        )}
        <LeftColumn>
          <div>
            {children ? children : (
              <T noTranslate><Title>{title}</Title></T>
            )}
            {subtitle && (
              <T noTranslate><Subtitle>{subtitle}</Subtitle></T>
            )}
          </div>
        </LeftColumn>
        {notice && 
        <NoticeColumn>
          {notice}
        </NoticeColumn>
        }
        {options && options.length > 0 && (
          <RightColumn>
            <MediaQuery maxWidth={500}>
              {this.renderOptions}
            </MediaQuery>
          </RightColumn>
        )}
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
  border-top: ${props => props.first ? `none` : `0.0625rem solid #e4e4e4`};
  min-height: 4.0625rem;
  padding: 0.5rem 1.875rem;
  transition: background 0.3s ease-in-out;

  :hover {
    background: #F5F5F8;
  }
`;

const AvatarContainer = styled.div`
  padding-right: 1rem;
  align-self: flex-start;
`;

const LeftColumn = styled.div`
  flex: 1;
  line-height: 1.50;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.strong`
  display: block;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Subtitle = styled.small`
  display: block;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RightColumn = styled.div`
  display: flex;
  align-items: center;
`;

const NoticeColumn = styled.div`
  padding-left: 1rem;
`;

export default ListItem;
